import { type ImageConstraints } from "@/types";

const gettext = (msg: string) => msg;

interface AppBenefit {
  title: string;
  copy: string;
  rating?: number;
  reviews?: string;
  dark: boolean;
  color: string;
  imageConstraints?: ImageConstraints;
  campaign: string;
}

interface CreatorsLanding {
  title: string;
  color: string;
  profileIds: string[];
  discoverLink: string;
}

export const creatorsModule: CreatorsLanding = {
  title: gettext("Follow these top creators on LTK"),
  color: "warm-grey-10",
  profileIds: [
    "ca00c62d-907f-11ee-8ea5-349d224349f4", // hannahstemme
    "263d4e4d-9087-11ee-8bd4-131d609744dd", // taryntruly
    "4bf59f5f-ff30-11e5-96ef-22000b0f8f3a", // iambeauticurve
  ],
  discoverLink: "",
};

export const benefits: AppBenefit[] = [
  {
    title: gettext("Join the shopping revolution"),
    copy: gettext("Over 10 million people use LTK to get updated when their favorite styles go on sale."),
    rating: 4.9,
    reviews: gettext("320,000+ reviews on the App store"),
    dark: true,
    color: "secondary-50",
    imageConstraints: {
      lg: { maxWidth: "100%" },
      md: { maxWidth: "100%" },
      sm: { maxWidth: "100%" },
      xs: { width: "100%" },
    },
    campaign: "Web_AppDLLP_AppStoreCTA1",
  },
  {
    title: gettext("Personalized style inspo at your fingertips"),
    copy: gettext("Follow amazing Creators (like @stylinbyaylin) to tailor your feed to your unique style"),
    dark: false,
    color: "ltk-white",
    imageConstraints: {
      lg: { maxWidth: "678", maxHeight: "472" },
      md: { maxWidth: "678", maxHeight: "472" },
      sm: { maxWidth: "678", maxHeight: "472" },
      xs: { width: "100%", maxWidth: "100%" },
    },
    campaign: "Web_AppDLLP_AppStoreCTA2",
  },
  {
    title: gettext("Build out your looks with curated wishlists"),
    copy: gettext("Save unique products, build out collections, and share them with your friends"),
    dark: false,
    color: "secondary-10",
    imageConstraints: {
      lg: { maxWidth: "1264", maxHeight: "488" },
      md: { maxWidth: "100%", maxHeight: "488" },
      sm: { maxWidth: "100%", maxHeight: "488" },
      xs: { width: "100%", maxWidth: "100%" },
    },
    campaign: "Web_AppDLLP_AppStoreCTA3",
  },
  {
    title: gettext("Never miss a sale or promotion again"),
    copy: gettext("Create an account to get personalized Sale, Promo, and Price Drop Notifications"),
    dark: false,
    color: "ltk-white",
    imageConstraints: {
      lg: { maxWidth: "1085", maxHeight: "536" },
      md: { maxWidth: "960", maxHeight: "539" },
      sm: { maxWidth: "100%", maxHeight: "539" },
      xs: { width: "100%", maxWidth: "100%" },
    },
    campaign: "Web_AppDLLP_AppStoreCTA4",
  },
];

export const ltkChatBenefits: AppBenefit[] = [
  {
    ...benefits[0],
    title: gettext("Install the App for group chat"), // Title for Chat Install Landing Page
    copy: gettext("Install the LTK App to see Chat content from Creators!"), // Copy for Chat Install Landing Page
  },
  ...benefits.slice(1),
];
